import { ConfigStateService } from '@abp/ng.core';
import { AfterViewInit, Component, OnInit, ViewChild } from '@angular/core';
import { MatSidenav } from '@angular/material/sidenav';
import { ActivatedRoute, Router } from '@angular/router';
import { OAuthService } from 'angular-oauth2-oidc';
import { Observable } from 'rxjs';
import { environment } from 'src/environments/environment';
import { ArtikelGruppen } from '../../store/models/artikelgruppen';
import { NavService } from '../nav/shared/nav.service';
import { WebfrontService } from '../../artikels/shared/webfront.service';
import { Webfront } from '../../store/models/webfront';
import { GridsterConfig,  GridsterItem }  from 'angular-gridster2';

@Component({
    selector: 'app-webshop-home',
    templateUrl: './webshophome.component.html',
    styleUrls: ['./webshophome.component.scss']
})
export class WebshopHomeComponent implements OnInit, AfterViewInit {

    // sidenav based on 
    // https://coderedirect.com/questions/170834/open-close-sidenav-from-another-component

    options: GridsterConfig;

    // Utils
    isLoading: boolean = true;
    webfront: Webfront.IWebfrontDto;

    dashboard: Array<GridsterItem>;

    constructor(
        private router: Router,
        private activatedRoute: ActivatedRoute,
        private navService: NavService,
        private oAuthService:OAuthService,
        private config: ConfigStateService,
        private webfrontService:WebfrontService
            ) {
                this.options = {
                    itemChangeCallback: this.itemChange,
                    itemResizeCallback: this.itemResize,
                    pushItems: true,
                    minRows:1,
                    maxRows:5,
                    minCols:1,
                    maxCols:5,
                  //  draggable:{enabled:true}
                  };
                
    }

    ngAfterViewInit(): void {
        this.webfrontService.getWebfront().subscribe(res => {
            if (res && res.items && res.items.length>0) {
                
                this.webfront = res;

                this.dashboard= res.items.map(di=>
                    {
                        //console.log(di);
                        
                        return {x:di.x,y:di.y,cols:di.width,rows:di.height,name:di.name};
                    });
                    this.options = {
                        itemChangeCallback: this.itemChange,
                        itemResizeCallback: this.itemResize,
                        pushItems: true,
                        minRows:res.height,
                        maxRows:res.height,
                        minCols:res.width,
                        maxCols:res.width,
                        //draggable:{enabled:true}
                      };

                this.isLoading = false;
            } else {
                this.skipWebfront();
            }
        });
     
    }

     itemChange(item, itemComponent) {
        console.info('itemChanged', item, itemComponent);
      }
    
       itemResize(item, itemComponent) {
       // console.info('itemResized', item, itemComponent);
      }

     
    ngOnInit(): void {

        let i= this.config.getFeature("Webshop.HasWelcomePage");
        if(i != 'true')
        {
            this.skipWebfront();
            
        }

      
    }

    skipWebfront()
    {
        this.router.navigate(["/articles"]);
    }

    changedOptions(): void {
        if (this.options.api && this.options.api.optionsChanged) {
          this.options.api.optionsChanged();
        }
      }
 
}
